import { render, staticRenderFns } from "./businessCompetitorList.vue?vue&type=template&id=0d94801a"
import script from "./businessCompetitorList.vue?vue&type=script&lang=js"
export * from "./businessCompetitorList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports